import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

const ImpressumPage: React.FC = () => (
  <div className="min-h-screen bg-gray-900 text-gray-100">
    <header className="bg-gray-800 border-b border-gray-700 px-4 sm:px-6 py-4 flex items-center gap-3">
      <Link to="/" className="text-gray-400 hover:text-white flex items-center gap-1">
        <BookOpen className="w-5 h-5" /> Hausaufgabenheft
      </Link>
      <span className="text-gray-600">·</span>
      <h1 className="text-xl font-semibold">Impressum</h1>
    </header>

    <main className="max-w-3xl mx-auto p-4 sm:p-6 space-y-6 text-gray-300 leading-relaxed">
      <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-3">
        <h2 className="text-xl font-semibold text-white">Angaben gemäß § 5 TMG</h2>
        <p>
          Dieses Hausaufgabenheft ist ein nicht-kommerzielles privates Projekt, entstanden am
          Girls'Day bei der <a href="https://vtrust.de" target="_blank" rel="noreferrer" className="text-blue-400">VTRUST GmbH</a>.
          Das vollständige Impressum des Trägerunternehmens findet sich unter{' '}
          <a href="https://vtrust.de/impressum" target="_blank" rel="noreferrer" className="text-blue-400">
            vtrust.de/impressum
          </a>.
        </p>
      </section>

      <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-3">
        <h2 className="text-xl font-semibold text-white">Verantwortlich für den Inhalt</h2>
        <p>
          Verantwortlich im Sinne von § 18 Abs. 2 MStV ist der Betreiber von{' '}
          <code>hw.z84.de</code>. Kontakt: <a href="mailto:hw@z84.de" className="text-blue-400">hw@z84.de</a>.
        </p>
      </section>

      <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-3">
        <h2 className="text-xl font-semibold text-white">Haftungsausschluss</h2>
        <p className="text-sm">
          Dieses Angebot ist nicht offizieller Bestandteil des Schulportals der Schule.
          Die Inhalte werden von den Schul-Portal-Servern abgerufen und nach bestem Wissen
          aufbereitet, aber ohne Gewähr auf Richtigkeit, Vollständigkeit oder Aktualität.
          Eine Haftung für Verlinkungen auf externe Inhalte (z.&nbsp;B. zum Schul-Portal) wird
          nicht übernommen; für diese ist ausschließlich deren Betreiber verantwortlich.
        </p>
      </section>

      <p className="text-sm">
        <Link to="/about" className="text-blue-400">Über das Projekt</Link>
        {' · '}
        <Link to="/datenschutz" className="text-blue-400">Datenschutz</Link>
      </p>
    </main>
  </div>
);

export default ImpressumPage;
